export default __webpack_public_path__ + "static/media/logo-mark.a479679e.svg";